import { FC, ReactElement } from 'react';

import { PdfPreviewDialog } from '../dialog';
import { usePdfPreviewService } from '../service';

export const PdfPreviewProvider: FC<{ children: ReactElement }> = ({ children }) => {
  const { config, closePreview } = usePdfPreviewService();

  return (
    <>
      {children}
      {config && <PdfPreviewDialog open={config.open} src={config.src} name={config.name} onClose={closePreview} />}
    </>
  );
};
